export default __webpack_public_path__ + "static/64ea6a8d8decfc4ba5395e29d420e1e1.jpg";